
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TimetableService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('timetable', http, authentication);
  }

  createReturn(body: any) {
    return this.http.post(this.url + '/make_return', body);
  }

}
